// Menufy menu item links mapping
// For specific item URLs, use format: https://www.orderroyalcurryleaf.com/#/Item/{itemId}/{categoryId}
// These IDs can be found by inspecting the Menufy ordering page
export const menufyLinks: Record<string, string> = {
  // APPETIZERS (Category 1302397)
  "MEDIUM VADA (2 PIECES)": "https://www.orderroyalcurryleaf.com/#/Item/14026391/1302397",
  "MEDHU VADA (2 PCS)": "https://www.orderroyalcurryleaf.com/#/Item/14026391/1302397",
  "MEDHU VADA 2 PCS": "https://www.orderroyalcurryleaf.com/#/Item/14026391/1302397",
  "IDLI SAMBAR (3 PCS)": "https://www.orderroyalcurryleaf.com/#/Item/14026395/1302397",
  "IDLI SAMBAR (3 PIECES)": "https://www.orderroyalcurryleaf.com/#/Item/14026395/1302397",
  "IDLI SAMBAR 3 PCS": "https://www.orderroyalcurryleaf.com/#/Item/14026395/1302397",
  "PANEER 65": "https://www.orderroyalcurryleaf.com/#/Item/14026392/1302397",
  "CHICKEN 65": "https://www.orderroyalcurryleaf.com/#/Item/14026396/1302397",
  "CHICKEN PEPPER FRY": "https://www.orderroyalcurryleaf.com/#/Item/14026393/1302397",
  "GOAT CHUKKA": "https://www.orderroyalcurryleaf.com/#/Item/14026397/1302397",
  "LAMB CHUKKA": "https://www.orderroyalcurryleaf.com/#/Item/14026394/1302397",
  "TAWA FISH FRY": "https://www.orderroyalcurryleaf.com/#/Item/14026398/1302397",
  
  // INDO-CHINESE (Category 1302398)
  "CHILLI CHICKEN": "https://www.orderroyalcurryleaf.com/#/Item/14026382/1302398",
  "VEG NOODLES": "https://www.orderroyalcurryleaf.com/#/Item/14026383/1302398",
  "EGG NOODLES": "https://www.orderroyalcurryleaf.com/#/Item/14026388/1302398",
  "EGG NOODLESS": "https://www.orderroyalcurryleaf.com/#/Item/14026388/1302398",
  "CHICKEN NOODLES": "https://www.orderroyalcurryleaf.com/#/Item/14026384/1302398",
  "CHICKEN NOODLESS": "https://www.orderroyalcurryleaf.com/#/Item/14026384/1302398",
  "VEG FRIED RICE": "https://www.orderroyalcurryleaf.com/#/Item/14026389/1302398",
  "EGG FRIED RICE": "https://www.orderroyalcurryleaf.com/#/Item/14026385/1302398",
  "PANEER FRIED RICE": "https://www.orderroyalcurryleaf.com/#/Item/14026390/1302398",
  "CHICKEN FRIED RICE": "https://www.orderroyalcurryleaf.com/#/Item/14026386/1302398",
  "CHILLI PANEER": "https://www.orderroyalcurryleaf.com/#/Item/14026387/1302398",
  
  // SOUTH INDIAN (Category 1302399)
  "PODI IDLI": "https://www.orderroyalcurryleaf.com/#/Item/14026376/1302399",
  "MINI IDLI": "https://www.orderroyalcurryleaf.com/#/Item/14026379/1302399",
  "MINI DOSA (2 PIECES)": "https://www.orderroyalcurryleaf.com/#/Item/14026377/1302399",
  "MASALA DOSA": "https://www.orderroyalcurryleaf.com/#/Item/14026380/1302399",
  "KOTHU PORATTA - VEG": "https://www.orderroyalcurryleaf.com/#/Item/14026378/1302399",
  "VEG KOTHU PORATTA": "https://www.orderroyalcurryleaf.com/#/Item/14026378/1302399",
  "KOTHU PORATTA - CHICKEN": "https://www.orderroyalcurryleaf.com/#/Item/14026381/1302399",
  "CHICKEN KOTHU PORATTA": "https://www.orderroyalcurryleaf.com/#/Item/14026381/1302399",
  
  // ENTREES (Category 1302400)
  "PANEER TIKKA MASALA": "https://www.orderroyalcurryleaf.com/#/Item/14026359/1302400",
  "CHICKEN TIKKA MASALA": "https://www.orderroyalcurryleaf.com/#/Item/14026363/1302400",
  "PANEER BUTTER MASALA": "https://www.orderroyalcurryleaf.com/#/Item/14026368/1302400",
  "BUTTER CHICKEN MASALA": "https://www.orderroyalcurryleaf.com/#/Item/14026372/1302400",
  "ROYAL VEG WHITE KORMA": "https://www.orderroyalcurryleaf.com/#/Item/14026371/1302400",
  "ROYAL CHICKEN WHITE KORMA": "https://www.orderroyalcurryleaf.com/#/Item/14026364/1302400",
  "SPECIAL CHICKEN CURRY": "https://www.orderroyalcurryleaf.com/#/Item/14026373/1302400",
  "SPECIAL GOAT CURRY": "https://www.orderroyalcurryleaf.com/#/Item/14026365/1302400",
  "SPECIAL LAMB CURRY": "https://www.orderroyalcurryleaf.com/#/Item/14026374/1302400",
  "SAAG PANEER": "https://www.orderroyalcurryleaf.com/#/Item/14026360/1302400",
  "SAAG LAMB": "https://www.orderroyalcurryleaf.com/#/Item/14026366/1302400",
  "BHINDI TAMARIND CURRY": "https://www.orderroyalcurryleaf.com/#/Item/14026362/1302400",
  "CHANNA MASALA": "https://www.orderroyalcurryleaf.com/#/Item/14026361/1302400",
  "FISH CURRY": "https://www.orderroyalcurryleaf.com/#/Item/14026375/1302400",
  "SHRIMP CURRY": "https://www.orderroyalcurryleaf.com/#/Item/14026367/1302400",
  "MALAI KOFTA": "https://www.orderroyalcurryleaf.com/#/Item/14026369/1302400",
  "DAL TADKA": "https://www.orderroyalcurryleaf.com/#/Item/14026370/1302400",
  
  // BREAD (Category 1302401)
  "NAAN": "https://www.orderroyalcurryleaf.com/#/Item/14026357/1302401",
  "GARLIC NAAN": "https://www.orderroyalcurryleaf.com/#/Item/14026358/1302401",
  
  // BIRYANI / RICE (Category 1302402)
  "HYDERABADI EGG DUM BRIYANI": "https://www.orderroyalcurryleaf.com/#/Item/14026354/1302402",
  "HYDERABADI EGG DUM BIRYANI": "https://www.orderroyalcurryleaf.com/#/Item/14026354/1302402",
  "HYDERABADI CHICKEN DUM BRIYANI": "https://www.orderroyalcurryleaf.com/#/Item/14026355/1302402",
  "HYDERABADI CHICKEN DUM BIRYANI": "https://www.orderroyalcurryleaf.com/#/Item/14026355/1302402",
  "HYDERABADI GOAT DUM BRIYANI": "https://www.orderroyalcurryleaf.com/#/Item/14026356/1302402",
  "HYDERABADI GOAT DUM BIRYANI": "https://www.orderroyalcurryleaf.com/#/Item/14026356/1302402",
  
  // DRINKS (Category 1302404)
  "MANGO LASSI": "https://www.orderroyalcurryleaf.com/#/Item/14026353/1302404",
  
  // DESSERT (Category 1302405)
  "KESARI (SOOJI HALWA)": "https://www.orderroyalcurryleaf.com/#/Item/14026352/1302405",
  
  // DINNER COMBO (Category 1302406)
  "ROYAL DUO FEAST": "https://www.orderroyalcurryleaf.com/#/Item/14026350/1302406",
  "ROYAL FAMILY SAVER": "https://www.orderroyalcurryleaf.com/#/Item/14026351/1302406"
};

// Helper function to find Menufy URL for a menu item
export const getMenufyUrl = (itemTitle: string): string | undefined => {
  const normalizedTitle = itemTitle.toUpperCase().trim();
  return menufyLinks[normalizedTitle];
};

// Base Menufy ordering URL
export const MENUFY_BASE_URL = "https://www.orderroyalcurryleaf.com/";

// Legacy exports for backward compatibility (deprecated - use getMenufyUrl and MENUFY_BASE_URL instead)
export const getToastTabUrl = getMenufyUrl;
export const TOAST_TAB_BASE_URL = MENUFY_BASE_URL;

